import { renderLocationSidebar } from './locationSidebar';

export const ADD_DICTIONARY_TEMPLATE = `
<div class="flex min-h-screen overflow-hidden bg-background-light">
${renderLocationSidebar('dictionaries')}
<main class="ml-64 flex-1 flex flex-col overflow-y-auto">
<header class="bg-white border-b border-slate-200 px-8 py-4 flex flex-col gap-1">
<nav class="flex items-center gap-2 text-xs font-medium text-slate-400 uppercase tracking-wider mb-1">
<a class="hover:text-primary transition-colors" href="/dictionaries">Management</a>
<span class="material-symbols-outlined text-xs">chevron_right</span>
<a class="hover:text-primary transition-colors" href="/dictionaries">Dictionaries</a>
<span class="material-symbols-outlined text-xs">chevron_right</span>
<span class="text-slate-600">New Entry</span>
</nav>
<h1 id="add-dictionary-page-title" class="text-2xl font-extrabold text-slate-900 tracking-tight">Create Dictionary Entry</h1>
</header>
<div class="p-8 max-w-5xl mx-auto w-full">
<div id="add-dictionary-alert" class="hidden mb-6 items-start gap-4 p-4 rounded-xl border">
<span id="add-dictionary-alert-icon" class="material-symbols-outlined"></span>
<div>
<p id="add-dictionary-alert-title" class="text-sm font-semibold"></p>
<p id="add-dictionary-alert-text" class="text-sm opacity-80"></p>
</div>
</div>
<div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
<div class="p-6 border-b border-slate-100 flex items-center gap-3">
<span class="material-symbols-outlined text-primary bg-primary/10 p-2 rounded-lg">edit_note</span>
<div>
<h2 class="text-lg font-bold text-slate-900">Entry Details</h2>
<p class="text-sm text-slate-500">Create a dictionary entry for Locations module.</p>
</div>
</div>
<form id="add-dictionary-form" class="p-8">
<div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
<div class="flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-name">Entry Name <span class="text-rose-500">*</span></label>
<input class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm" id="entry-name" placeholder="e.g., Mountain Pass" type="text"/>
</div>
<div class="flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-slug">System Code (Slug)</label>
<input class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm" id="entry-slug" placeholder="mountain-pass" type="text"/>
<p class="text-[11px] text-slate-400 italic">Auto-generated from name if left empty.</p>
</div>
<div class="flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-module">Module Association</label>
<select class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm" id="entry-module">
<option value="locations" selected>Locations</option>
<option value="routes">Routes</option>
<option value="news">News</option>
<option value="events">Events</option>
</select>
</div>
<div class="flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-type">Dictionary Type</label>
<select class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm" id="entry-type">
<option value="countries">Countries</option>
<option value="regions">Regions</option>
<option value="counties">Counties</option>
<option value="settlements">Settlements</option>
<option value="tags">Tags</option>
<option value="location-categories">Categories</option>
<option value="location-road-types">Road Types</option>
<option value="location-difficulties">Difficulties</option>
<option value="location-best-seasons">Best Seasons</option>
<option value="route-categories">Route Categories</option>
<option value="route-tags">Route Tags</option>
<option value="news-categories">News Categories</option>
<option value="news-tags">News Tags</option>
<option value="event-types">Event Types</option>
</select>
</div>
<div id="entry-parent-country-wrap" class="hidden flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-parent-country">Parent Country <span class="text-rose-500">*</span></label>
<select id="entry-parent-country" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm">
<option value="">Select country</option>
</select>
</div>
<div id="entry-parent-region-wrap" class="hidden flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-parent-region">Parent Region <span class="text-rose-500">*</span></label>
<select id="entry-parent-region" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm">
<option value="">Select region</option>
</select>
</div>
<div id="entry-parent-county-wrap" class="hidden flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-parent-county">Parent County <span class="text-rose-500">*</span></label>
<select id="entry-parent-county" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm">
<option value="">Select county</option>
</select>
</div>
<div class="flex flex-col gap-2">
<label class="text-sm font-bold text-slate-700" for="entry-order">Sort Order</label>
<input class="w-full bg-slate-50 border-slate-200 rounded-lg focus:ring-primary focus:border-primary transition-all p-3 text-sm" id="entry-order" type="number" value="0"/>
</div>
<div class="flex flex-col gap-2 md:col-span-2">
<label class="text-sm font-bold text-slate-700">Status</label>
<label class="inline-flex items-center gap-3 py-1">
<input id="entry-active" class="h-4 w-4 rounded border-slate-300 text-primary focus:ring-primary" type="checkbox" checked/>
<span class="text-sm text-slate-600">Is Active</span>
</label>
</div>
</div>
</form>
<div class="px-8 py-6 bg-slate-50 border-t border-slate-200 flex flex-wrap items-center justify-between gap-4">
<a class="px-5 py-2.5 text-sm font-bold text-slate-600 hover:text-slate-900 transition-colors" href="/dictionaries">Cancel</a>
<div class="flex items-center gap-3">
<button id="add-dictionary-save-next-btn" class="px-5 py-2.5 text-sm font-bold text-primary bg-primary/10 hover:bg-primary/20 rounded-lg transition-all" type="button">Save &amp; Add Next</button>
<button id="add-dictionary-save-btn" class="px-8 py-2.5 text-sm font-bold text-white bg-primary hover:bg-primary/90 rounded-lg shadow-md shadow-primary/20 transition-all flex items-center gap-2" type="button">
<span class="material-symbols-outlined text-[18px]">check_circle</span>
<span id="add-dictionary-save-btn-label">Save Entry</span>
</button>
</div>
</div>
</div>
</div>
</main>
</div>
`;
